var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53 0H19a5.01 5.01 0 0 0-4.899 4H13c-3.859 0-7 3.14-7 7v46c0 3.86 3.141 7 7 7h35c3.859 0 7-3.14 7-7v-1.424A5.003 5.003 0 0 0 58 51V5c0-2.757-2.243-5-5-5zM18 5c0-.551.448-1 1-1h34c.552 0 1 .449 1 1v46c0 .551-.448 1-1 1H19c-.552 0-1-.449-1-1zm30 55H13c-1.654 0-3-1.346-3-3V11c0-1.654 1.346-3 3-3h1v43c0 2.757 2.243 5 5 5h32v1c0 1.654-1.346 3-3 3z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 22c.512 0 1.023-.195 1.414-.586L32 14.829l5.586 5.585a2 2 0 0 0 2.828 0L45 15.828l.586.586a2 2 0 0 0 3.375-1.022l1-5a2.003 2.003 0 0 0-2.354-2.353l-5 1a1.998 1.998 0 0 0-1.021 3.375l.586.586L39 16.171l-5.586-5.585a2 2 0 0 0-2.828 0l-8 8A2 2 0 0 0 24 22zM24 30h24a2 2 0 0 0 0-4H24a2 2 0 0 0 0 4zM48 36H25a2 2 0 0 0 0 4h23a2 2 0 0 0 0-4zM37 44H25a2 2 0 0 0 0 4h12a2 2 0 0 0 0-4z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.6f1cf79cd5deb57f1152542c96115691.svg";
export { ForwardRef as ReactComponent };